import React, { useState } from "react";

import PropTypes from "prop-types";

import { ReactComponent as LaunchIcon } from "../../assets/icons/launch.svg";
import { ReactComponent as SwapIcon } from "../../assets/icons/swap.svg";
import Logo from "../../assets/images/ntb-logo.svg";
import style from "../../assets/scss/components/user-menu.module.scss";

function UserExternalLink({
  url,
  darkLogo,
  lightLogo,
  isDarkMode,
  width,
  label,
  visible,
  displayLogo
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      {visible && (
        <a
          className={style["user-menu__dropdown__item"]}
          href={url}
          rel="noreferrer"
          target="_blank"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div>
            {darkLogo && lightLogo && (
              <div className={style["user-menu__dropdown__item__logo"]} style={{ width: width }}>
                {isDarkMode ? darkLogo : lightLogo}
              </div>
            )}
            {/* {displayLogo && <img alt={"logo"} src={Logo} />} */}
            {!displayLogo && label && <div>{label}</div>}
          </div>
          {!isHovered ? <LaunchIcon /> : <SwapIcon />}

          {/* <div className={style["user-menu__dropdown__item__logo"]} style={{ width: width }}>
            {isDarkMode ? darkLogo : lightLogo}
          </div>
          <div style={{ float: "right" }}>{!isHovered ? <LaunchIcon /> : <SwapIcon />}</div> */}

          {/* <span className={style["user-menu__dropdown__item__logo"]} style={{ width: width }}>
            {isDarkMode ? darkLogo : lightLogo}
          </span>
          <span style={{ float: "right" }}>{!isHovered ? <LaunchIcon /> : <SwapIcon />}</span> */}
        </a>
      )}
    </>
  );
}

UserExternalLink.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  displayLogo: PropTypes.bool,
  darkLogo: PropTypes.element,
  lightLogo: PropTypes.element,
  isDarkMode: PropTypes.bool,
  width: PropTypes.string
};

UserExternalLink.defaultProps = {
  visible: true,
  displayLogo: false
};

export default UserExternalLink;
